document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  // 全セクションを自動で対象にする
  document.querySelectorAll('.shopify-section').forEach(el => {
    el.classList.add('fade-in-section');
    observer.observe(el);
  });
});
